import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  FormHelperText,
  Checkbox,
  Typography,
  Autocomplete,
  ClickAwayListener,
  AutocompleteCloseReason,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
  styled,
  Popper,
  Divider,
} from "@mui/material";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const UploadDoc = (props) => {
  const {
    openDialog,
    handleClose,
    register,
    handleSubmit,
    errors,
    modelList,
    docTypeList,
    allBrands,
    modelDescription,
    setValue,
    onUploadSubmit,
    setFile,
    onBrickSelect,
    handleChange,
    sendNotification,
    disableModelDropdown,
    isEditMode,
    formData,
    disableCategoryDropdown,
    disableFamilyDropdown,
    disableBrickDropdown,
    setIsUpdateButton,
    categoryListOnBrandId,
    productFamilyList,
    onFamilyClick,
    onBrandSelectedClick,
    onCategoryClickInModel,
    brickList,
    setSelectedModelIds,
    setSelectedDeptlIds,
    departmentList,
    clearErrors,
    autoC1,
    clearModel,
    autoC,
    modelIdData,
    deptIdData,
    selectedModelIds,
    selectedDeptIds
    } = props;
  const { content } = brickList;
  const [checkAll, setCheckAll] = React.useState(false);
  const [checkAllDepartment, setCheckAllDepartment] = React.useState(false);
  const PopperStyledComponent = styled(Popper)(({ theme }) => ({
    border: `1px solid ${
      theme.palette.mode === "light" ? "rgba(149, 157, 165, 0.2)" : "rgb(1, 4, 9)"
    }`
  }));
  const [open, setOpen] = React.useState(false);
  const handleClickAway = (e) => {
    console.log("Handle Click Away");
    setOpen(false);
  };
  const checkAllModel = (event) => {
    setCheckAll(event.target.checked);
    modelIdData.length=0;
    clearErrors("model_id");
    if (event.target.checked) {
      modelList.map((d) => {
      modelIdData.push(d);});
      setValue("model_id", modelIdData);
      setSelectedModelIds(modelIdData);
      setModelValue(modelIdData)
    } else {
      setValue("model_id", []);
      setSelectedModelIds([]);
      setModelValue([])
    }
  };
  const checkAllDept = (event) => {
    setCheckAllDepartment(event.target.checked);
    deptIdData.length=0;
    clearErrors("dept_Id");
    if (event.target.checked) {
      departmentList.map((d) => {
      deptIdData.push(d);});
      setValue("dept_Id", deptIdData);
      setSelectedDeptlIds(deptIdData);
      setDeptValue(deptIdData);
    } else {
      setValue("dept_Id", []);
      setSelectedModelIds([]);
      setDeptValue([]);
    }
  };
  const [productCategoryId, setProductCategoryId] = useState(
    formData?.categoryId ?? null
  );
  const [deptValue, setDeptValue] = React.useState([]);
  const [modelValue, setModelValue] = React.useState([]);
  const [productCatFamilyMappingId, setProductCatFamilyMappingId] = useState(
    formData?.productFamilyId ?? null
  );
  const [brickIdVal, setBrickId] = useState(formData?.brickId ?? null);
 
  const inputFileRef = React.useRef();
  
  useEffect(() => {
    setValue("modelDescription", modelDescription);
    
  }, [modelDescription]);
   
  useEffect(() => {
    setProductCategoryId(formData?.categoryId);
    setProductCatFamilyMappingId(formData?.productFamilyId);
    setBrickId(formData?.brickId);
    setDeptValue(deptIdData);
    setModelValue(modelIdData);
    setCheckAllDepartment(false);
    setCheckAll(false);
  }, [openDialog, isEditMode]
  
   );

  return (
    <>
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>{isEditMode ? "Edit" : "Upload"} Technical Documents</b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 4, pb: 0 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center">
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sm={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}>
                            Brand
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Select Category"
                            name="brandId"
                            fullWidth
                            size="small"
                            autoComplete="off"
                            defaultValue={formData.brandId}
                           
                            {...register("brandId", {
                              required: "This field is required",
                            })}
                            error={Boolean(errors?.brandId)}
                            helperText={errors?.brandId?.message}>
                            {allBrands &&
                              allBrands.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.brandId}
                                    sx={{ width: "100%" }}
                                    value={d.brandId}
                                    size="small"
                                    onClick={() => {
                                      onBrandSelectedClick(d.brandId, d.name);
                                      setProductCategoryId(null);
                                      setBrickId(null);
                                      setProductCatFamilyMappingId(null);
                                      clearModel(autoC);
                                      setValue("brickId",null)
                                      setValue("productCategoryId",null)
                                      setValue("productCatFamilyMappingId",null)
                                      setValue("model_id",null)
                                    }}>
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.brandId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}>
                            Product Category
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Product Category"
                            name="productCategoryId"
                            fullWidth
                            size="small"
                            
                            value={productCategoryId ?? null}
                            autoComplete="off"
                            {...register("productCategoryId", {
                              required: "This field is required",
                            })}
                            disabled={disableCategoryDropdown}
                            error={Boolean(errors?.productCategoryId)}
                            helperText={errors?.productCategoryId?.message}
                            
                            onChange={(e) => {
                              setProductCategoryId(e.target.value);
                             
                            }}>
                            {categoryListOnBrandId &&
                            categoryListOnBrandId.length > 0 ? (
                              categoryListOnBrandId?.map((d) => {
                                return (
                                  <MenuItem
                                    key={d?.productCategoryId}
                                    sx={{ width: "100%" }}
                                    value={d?.productCategoryId}
                                    size="small"
                                    onClick={(e) => {
                                     
                                      onCategoryClickInModel(
                                        d?.productCategoryId,
                                        d?.name
                                      );
                                      setBrickId(null);
                                      setProductCatFamilyMappingId(null);
                                    }}>
                                    {d?.name}
                                  </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem>Record not found</MenuItem>
                            )}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.productCategoryId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Segment-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Product Family
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            name="productCatFamilyMappingId"
                            label="Product Family"
                            fullWidth
                           
                            value={
                              productCatFamilyMappingId ??
                              formData?.productCatFamilyMappingId ??
                              null
                            }
                            size="small"
                            autoComplete="off"
                            {...register("productCatFamilyMappingId", {
                              required: "This field is required",
                            })}
                            disabled={disableFamilyDropdown}
                            error={Boolean(errors?.productCatFamilyMappingId)}
                            helperText={
                              errors?.productCatFamilyMappingId?.message
                            }
                            onChange={(e) => {
                              setProductCatFamilyMappingId(e.target.value);
                             
                            }}>
                            {productFamilyList?.content &&
                              productFamilyList?.content.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.productCatFamilyMappingId}
                                    sx={{ width: "100%" }}
                                    value={d.productCatFamilyMappingId}
                                    size="small"
                                    onClick={(e) => {
                                     
                                      onFamilyClick(
                                        d.productCatFamilyMappingId,
                                        d.productFamilyName
                                      );
                                      setBrickId(null);
                                      setIsUpdateButton(false);
                                    }}>
                                    {d.productFamilyName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors &&
                              errors?.productCatFamilyMappingId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Brick-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Brick
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            name="brickId"
                            label="Brick"
                            fullWidth
                           
                            value={brickIdVal ?? formData?.brickId ?? null}
                            size="small"
                            disabled={disableBrickDropdown}
                            autoComplete="off"
                            {...register("brickId", {
                              required: "This field is required",
                            })}
                            error={Boolean(errors?.brickId)}
                            helperText={errors?.brickId?.message}
                            onChange={(e) => {
                              setBrickId(e.target.value);
                             
                            }}>
                            {content &&
                              content.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.brickId}
                                    sx={{ width: "100%" }}
                                    value={d.brickId}
                                    size="small"
                                    onClick={(e) => {
                                     
                                      onBrickSelect(d.brickId);
                                      setIsUpdateButton(false);
                                    }}>
                                    {d.brickName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.brickId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sm={6} sx={{ pr: 1 }}>
                        <Autocomplete
                          multiple
                          limitTags={1}
                          id="checkboxes-tags-demo"
                          name="model_id"
                          options={modelList ?? []}
                          {...register("model_id", {
                            required: "This field is required",
                          })}
                          ref={autoC}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option?.description}
                          //defaultValue={modelIdData}
                          value={modelValue}
                          defaultChecked={modelIdData}
                          disabled={disableModelDropdown}
                          onBlur ={(event, newValue, reason) => {
                            setValue("model_id", selectedModelIds);
                          }}
                          error={Boolean(errors?.model_id)}
                          helperText={errors?.model_id?.message}
                          onChange={(event, newValue, reason) => {
                            if (reason === "selectOption") {
                              clearErrors("model_id");
                              setValue("model_id", newValue);
                              setSelectedModelIds(newValue);
                              setModelValue(newValue)
                             
                            } else if (reason === "removeOption") {
                              setCheckAll(false);
                              clearErrors("model_id");
                              setValue("model_id", newValue);
                              setSelectedModelIds(newValue);
                              setModelValue(newValue)
                             
                            } else if (reason === "clear") {
                              clearErrors("model_id");
                              setValue("model_id", newValue);
                              setSelectedModelIds(newValue);
                              setCheckAll(false);
                              setModelValue([])
                              
                            }
                          }}
                          size="small"
                          PopperComponent={(param) => (
                            <PopperStyledComponent {...param}>
                              <Box
                                sx={{
                                  backgroundColor: "white",
                                  height: "40px",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap"
                                }}
                              >
                                <Checkbox
                                  checked={checkAll}
                                  onChange={checkAllModel}
                                  id="check-all"
                                  size="small"
                                  sx={{ marginRight: "8px" }}
                                  onMouseDown={(e) => e.preventDefault()}
                                />
                                Select All
                              </Box>
                              <Box {...param} />
                            </PopperStyledComponent>
                          )}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8, marginLeft: -15 , marginBlock: -50}}
                                checked={selected || checkAll}
                              />
                              {option?.fgCode + " -" + option?.description}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={Boolean(errors?.model_id)}
                              helperText={errors?.model_id?.message}
                              label="Model"
                              placeholder="select Model"
                            />
                          )}
                        />
                        
                        {isEditMode ? (setValue("model_id", modelIdData)):""}
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Is Downloadable?
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Is Downloadable?"
                            name="isDownloadAble"
                            fullWidth
                            defaultValue={formData.isDownloadable}
                            size="small"
                            autoComplete="off"
                           
                            {...register("isDownloadAble",{
                              required: "This field is required",
                            })}
                            error={Boolean(errors?.isDownloadAble)}
                            helperText={errors?.isDownloadAble?.message}
                            >
                            <MenuItem
                              native
                              sx={{ width: "100%" }}
                              value={1}
                              size="small">
                              Yes
                            </MenuItem>
                            <MenuItem
                              native
                              sx={{ width: "100%" }}
                              value={0}
                              size="small">
                              No
                            </MenuItem>
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.isDownloadAble?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}>
                            Select Type
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Select Type"
                            name="typeId"
                            fullWidth
                            size="small"
                            autoComplete="off"
                            defaultValue={formData.docTypeId}
                            {...register("typeId", {
                              required: "This field is required",
                            })}
                            error={Boolean(errors?.typeId)}
                            helperText={errors?.typeId?.message}
                            
                          >
                            {docTypeList &&
                              docTypeList.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.id}
                                    sx={{ width: "100%" }}
                                    value={d.id}
                                    size="small">
                                    {d.description}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.typeId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                      <ClickAwayListener onClickAway={handleClickAway}>
                        <FormControl fullWidth>
                          <Autocomplete
                            name="dept_Id"
                            fullWidth
                            multiple
                            limitTags={1}
                            id="checkboxes-tags-demo1"
                            options={departmentList ?? []}
                            disableCloseOnSelect
                            
                            defaultChecked={deptIdData}
                            getOptionLabel={(option) => option?.name}
                            //defaultValue={deptIdData}
                            value = { deptValue}
                            {...register("dept_Id", {
                              required: "This field is required",
                            })}
                            ref={autoC1}
                            error={Boolean(errors?.dept_Id)}
                            helperText={errors?.dept_Id?.message}
                            onBlur ={(event, newValue, reason) => {
                              setValue("dept_Id", selectedDeptIds);
                            }}
                            onChange={async (event, newValue, reason) => {
                              if (reason === "selectOption") {
                                clearErrors("dept_Id");
                                setValue("dept_Id", newValue);
                                setSelectedDeptlIds(newValue);
                                setDeptValue(newValue);
                              } else if (reason === "removeOption") {
                                setCheckAllDepartment(false);
                                clearErrors("dept_Id");
                                setValue("dept_Id", newValue);
                                setSelectedDeptlIds(newValue);
                                setDeptValue(newValue);
                              } else if (reason === "clear") {
                                clearErrors("dept_Id");
                                setValue("dept_Id", newValue);
                                setSelectedDeptlIds(newValue);
                                setCheckAllDepartment(false);
                                setDeptValue([]);
                              }
                            }}
                            open={open}
                            onClose={(e, reason) => {
                              console.log("On Close: ", reason);
                              if (reason === "escape") {
                                setOpen(false);
                              }
                            }}
                            onOpen={() => {
                              setOpen(true);
                            }}
                            size="small"
                            PopperComponent={(param) => (
                              <PopperStyledComponent {...param}>
                                <Box
                                  sx={{
                                    backgroundColor: "white",
                                    height: "40px",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  <Checkbox
                                    checked={checkAllDepartment}
                                    onChange={checkAllDept}
                                    id="check-all-department"
                                    size="small"
                                    sx={{ marginRight: "8px" }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  />
                                  Select All
                                </Box>
                                <Box {...param} />
                              </PopperStyledComponent>
                            )}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 , marginLeft: -15 , marginBlock: -50}}
                                  checked={selected || checkAllDepartment}
                                />
                                {option?.name}
                              </li>
                            )}
                            
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Department"
                                placeholder="select department"
                                error={Boolean(errors?.dept_Id)}
                                helperText={errors?.dept_Id?.message}
                              />
                            )}
                          />
                         {isEditMode ? ( setValue("dept_Id", deptIdData)):"" }
                        </FormControl>
                        </ClickAwayListener>
                      </Grid>
                      <Grid container>
                        <Grid item xs={6} sm={6} sx={{ mt: 1, pr: 1 }}>
                          <TextField
                            className="stepperFormInput"
                            label="Short Description"
                            name="techDocDesc"
                            placeholder="Enter short description"
                            fullWidth
                            required
                            size="small"
                            autoComplete="off"
                            {...register("techDocDesc", {
                              required: "This field is required",
                              pattern: {
                                value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^{}<>\n]+$/,
                                message: "Field can not start with special characters and exlclude {}<>",
                              },
                              maxLength: {
                                value: 250,
                                message: "Max length should be 250 only",
                              },
                            })}
                            error={Boolean(errors?.techDocDesc)}
                            helperText={errors?.techDocDesc?.message}
                            
                          />
                          <Typography
                            sx={{
                              fontSize: "8px",
                              color: "#909090",
                              textAlign: "right",
                            }}>
                            max 250 characters
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} sx={{ mt: 1 }}>
                          <input
                            type="file"
                            accept=".doc,
                          .docx,
                          application/pdf,
                          .ppt,
                          .pptx,
                          .exe,
                          .mp4,
                          .msi,
                          .zip,
                          .xls,
                          .xlsx,
                          .csv
                          "
                            id="upload-button"
                            style={{ width: "240px" }}
                            ref={inputFileRef}
                            onChange={(e) => setFile(e.target.files[0])}
                          />
                          {isEditMode ? (
                            <span className="_fileNameCssBLock">
                              Selected file is :{" "}
                              <span style={{ color: '#003f93' }}>
                                {formData.fileName}{" "}
                              </span>
                            </span>
                          ) : (
                            clearModel
                          )}
                        </Grid>

                        <Grid
                          item
                          xs={6}
                          sx={{
                            pr: 1,
                            color: "#003f93",
                            
                          }}>
                          <NotificationsActiveIcon> </NotificationsActiveIcon>{" "}
                          Send Notification
                          <Checkbox
                            checked={sendNotification}
                            onChange={handleChange}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 0 }}>
                      {sendNotification ? (
                        <TextField
                          className="stepperFormInput"
                          label="Notification Description"
                          name="shortDesc"
                          fullWidth
                          required
                          size="small"
                          
                          autoComplete="off"
                          {...register("shortDesc", {
                            required: "This field is required",
                            pattern: {
                              value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^{}<>\n]+$/,
                              message: "Field can not start with special characters and exlclude {}<>",
                            },
                            minLength: {
                              value: 3,
                              message: "Min length should be 3 only",
                            },
                            maxLength: {
                              value: 2000,
                              message: "Max length should be 2000 only",
                            },
                          })}
                          error={Boolean(errors?.shortDesc)}
                          helperText={errors?.shortDesc?.message}
                          onBlur={(e) => {
                            let str = e.target.value;
                            setValue("shortDesc", str.trim());
                           
                          }}
                          
                        />
                      ) : null}
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <React.Fragment>
              <Box
                sx={{
                  display: "block",
                  textAlign: "right",
                  p: 1,
                  pb: 2,
                  mt: 0,
                }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onUploadSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained">
                  Save
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 2 }}
                  className="button-primary-alt-contained">
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default UploadDoc;
